const getNewThread = () => {
  return {
    resourceType: 'discussion',
    resourceId: '',
    groupSettings: {
      name: '',
      description: null,
      icon: {
        image: null,
        imageBase: null
      },
      color: null,
      useColorAsBg: false
    }
  };
};

export default getNewThread;
